/**
 * UnauthorizedScreen.tsx — the clean "not authorized" state.
 *
 * Shown when a signed-in account lacks the `BackofficeUser` App Role (BFF returns 403)
 * — per spec, auth failure must render a clean state, never a broken page.
 * Renders inside the shell's <main>, so the root is a <div> (no nested landmark).
 */

import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/Button';

export const UnauthorizedScreen = () => {
  const { t } = useTranslation();
  const { instance } = useMsal();
  return (
    <div
      role="alert"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <span className="font-display text-h1 text-gold">Tucunã</span>
      <h1 className="text-h1 text-ink-1">{t('auth.unauthorizedTitle')}</h1>
      <p className="max-w-md text-body text-ink-2">{t('auth.unauthorizedBody')}</p>
      <div className="flex gap-3">
        <Button variant="primary" onClick={() => window.location.reload()}>
          {t('auth.retry')}
        </Button>
        <Button
          data-testid="unauthorized-sign-out"
          onClick={() => {
            instance.logoutRedirect().catch(() => {});
          }}
        >
          {t('auth.signOut')}
        </Button>
      </div>
    </div>
  );
};
